module.exports = __webpack_public_path__ + "static/media/Archive.97e6dead.zip";